var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',{staticClass:"footer"},[(_vm.isRestaurantSelected)?_c('p',[_vm._v(" "+_vm._s(_vm.currentRestaurant.restaurantName)+" ")]):_vm._e(),(_vm.isRestaurantSelected)?_c('p',[_vm._v(" Org.nr. "+_vm._s(_vm.currentRestaurant.organizationNumber)+" ")]):_vm._e(),_c('p',[_vm._v("Fuji sushi Web app v2.0 ®2021 Created by Transoft ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }